module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_8003.122f129c.png";